module.exports = __webpack_public_path__ + "static/img/seat.bc93786.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/seat.png
// module id = wop9
// module chunks = 1